<template>
  <div v-if="loading">
    <spinner />
  </div>
  <div v-else class="container">
    <membership-plan-list
      v-if="activeStep === 1"
      :initial-values="membershipPlans"
      @createNewPlan="activeStep = 2"
      @editPlan="handleEdit($event)"
      @delete="handleDelete"
    />
    <create-or-edit-membership
      v-if="activeStep === 2"
      :initial-value="initialValue"
      :order-item-templates="orderItemTemplates"
      @cancel="handleReset"
      @create="handleCreate"
      @update="handleUpdate"
    />
    <simple-snackbar
      :open.sync="snackbar.open"
      :message-prop="snackbar.message"
      :color="snackbar.color"
    />
  </div>
</template>

<script>
import MembershipPlanList from '@/components/organizations/memberships/MembershipPlanList.vue'
import CreateOrEditMembership from '@/components/organizations/memberships/CreateOrEditMembership.vue'
import {
  CREATE_MEMBERSHIP_PLAN,
  DELETE_MEMBERSHIP_PLAN,
  GET_ORGANIZATION_MEMBERSHIP_PLANS_AND_ORDER_ITEM_TEMPLATES,
  UPDATE_MEMBERSHIP_PLAN,
} from '../../../graphql/membershipPlan.graphql'
import Spinner from './../../shared/spinner.vue'
import SimpleSnackbar from '@/components/shared/snackbars/simple-snackbar.vue'

export default {
  name: 'memberships-plan-container',
  components: {
    MembershipPlanList,
    CreateOrEditMembership,
    SimpleSnackbar,
    Spinner,
  },
  props: {
    organizationSlug: {
      type: String,
    },
  },
  data() {
    return {
      activeStep: 1,
      membershipPlans: [],
      orderItemTemplates: [],
      loading: true,
      initialValue: {},
      snackbar: {
        open: false,
        message: '',
        color: 'primary',
      },
    }
  },
  async mounted() {
    await this.fetchPrepaidCouponsAndEventTemplatesAndOrganizationInterests()
  },
  methods: {
    async handleCreate(info) {
      const { orderItemTemplates, ...membershipPlanInput } = info

      const { errors } = await this.$apollo.mutate({
        mutation: CREATE_MEMBERSHIP_PLAN,
        variables: {
          organizationSlug: this.organizationSlug,
          orderItemTemplates: orderItemTemplates.map(oit => oit.id || oit),
          membershipPlanInput: membershipPlanInput,
        },
      })
      await this.showSnackbarMsgAndRefetchData(errors, 'Plan created')
    },
    async handleUpdate(info) {
      console.log(info)
      const { id, orderItemTemplate , orderItemTemplates, ...membershipPlanInput } = info
      const { errors } = await this.$apollo.mutate({
        mutation: UPDATE_MEMBERSHIP_PLAN,
        variables: {
          organizationSlug: this.organizationSlug,
          membershipPlanId:id,
          orderItemTemplates: orderItemTemplates.map(oit => oit.id || oit),
          membershipPlanInput,
        },
      })
      await this.showSnackbarMsgAndRefetchData(errors, 'Plan updated')
    },
    async handleDelete(selected) {
      const { errors } = await this.$apollo.mutate({
        mutation: DELETE_MEMBERSHIP_PLAN,
        variables: {
          organizationSlug: this.organizationSlug,
          membershipPlanId: selected.map(s => parseInt(s)),
        },
      })
      this.activeStep = 0
      await this.showSnackbarMsgAndRefetchData(errors, 'Plan deleted')
    },
    async handleRefetchData() {
      await this.fetchPrepaidCouponsAndEventTemplatesAndOrganizationInterests()
      this.handleReset()
    },
    async showSnackbarMsgAndRefetchData(errors, msg) {
      if (errors) {
        this.snackbar = {
          open: true,
          message: 'Oops, something went wrong!',
          color: 'error',
        }
      } else {
        this.snackbar = {
          open: true,
          message: `${msg} successfully!`,
        }
        await this.handleRefetchData()
      }
    },
    handleEdit(selectedPlanId) {
      this.initialValue = this.membershipPlans.find(plan => plan.id === selectedPlanId)
      this.activeStep = 2
    },
    handleReset() {
      this.activeStep = 1
      this.initialValue = {}
    },
    async fetchPrepaidCouponsAndEventTemplatesAndOrganizationInterests() {
      const { data, errors } = await this.$apollo.query({
        query: GET_ORGANIZATION_MEMBERSHIP_PLANS_AND_ORDER_ITEM_TEMPLATES,
        variables: {
          organizationSlug: this.organizationSlug,
        },
      })
      if (errors) {
        await this.showSnackbarMsgAndRefetchData(errors)
      } else {
        this.membershipPlans = data.getOrganizationMembershipPlans
        console.log(this.membershipPlans)
        this.orderItemTemplates = data.getOrganizationOrderItemTemplates
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.container {
  padding: 0 !important;
  margin: 0 !important;
  display: flex;
  flex-direction: column;
  max-width: 43.75rem;
}
</style>
